// localStorage에 selectedLanguage가 없을 때 defaultLanguage 적용
const useGetLocalStorageLanguage = (defaultLanguage = 'en') => {
  let selectedLanguage = localStorage.getItem('selectedLanguage');
  if (selectedLanguage) {
    return selectedLanguage;
  } else {
    return defaultLanguage; // 별도의 localStorage의 값이 없는 경우 기본값 설정
  }
};

export default useGetLocalStorageLanguage;
